import { useQuery } from "react-query";

import { dataCleanseService } from "services";
import { MissingScheduleAResidualSplitProfileTypes } from "types";

export type useMissingScheduleAResidualSplitProfileListQueryProps = {
	paidMonth: Date | string;
	paidYear: Date | string;
	fetchData: { page: number; filters: any; sortBy: { [key: string]: any } };
	isRefreshDataCleanse: boolean;
};

const useMissingScheduleAResidualSplitProfileListQuery = ({
	fetchData,
	isRefreshDataCleanse,
	paidMonth,
	paidYear,
}: useMissingScheduleAResidualSplitProfileListQueryProps) => {
	const { page, filters, sortBy } = fetchData;

	const getMissingFilterValue = () => {
		if (
			filters?.missing?.name ===
			MissingScheduleAResidualSplitProfileTypes.ScheduleA.name
		)
			return { isScheduleAMissing: true };
		else if (
			filters?.missing?.name ===
			MissingScheduleAResidualSplitProfileTypes.ResidualSplitProfile.name
		)
			return { isSplitProfileMissing: true };
		else if (
			filters?.missing?.name ===
			MissingScheduleAResidualSplitProfileTypes.ScheduleASplitProfile.name
		)
			return {
				isSplitProfileMissing: true,
				isScheduleAMissing: true,
			};
		else return undefined;
	};

	const fetchMissingScheduleAResidualSplitProfileLisList = () =>
		dataCleanseService.getDataCleanseLists({
			paidMonth,
			paidYear,
			isMissingScheduleASplitProfile: true,
			page,
			filters: {
				...filters,
				...getMissingFilterValue(),
			},
			sortBy,
		});

	const queryResult = useQuery(
		[
			"missingScheduleASplitProfile",
			paidMonth,
			paidYear,
			page,
			isRefreshDataCleanse,
			filters,
			sortBy,
		],
		fetchMissingScheduleAResidualSplitProfileLisList,
		{
			keepPreviousData: true,
			staleTime: 5000,
			retry: false,
		},
	);

	return queryResult;
};

export default useMissingScheduleAResidualSplitProfileListQuery;
